exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.collapsible-content[data-v-0600ce13] {\n    will-change: height;\n    -webkit-transform: translateZ(0);\n            transform: translateZ(0);\n    -webkit-backface-visibility: hidden;\n            backface-visibility: hidden;\n    -webkit-perspective: 1000px;\n            perspective: 1000px;\n}\n", ""]);

// exports
